export const NOTIFICATIONS_OBSERVER_PRIVATE = Symbol('notifications-observer-private');
//# sourceMappingURL=privates.js.map